import styled from 'styled-components';
import { Flex } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { UrlFilters } from '@elementary/common-ui/hooks/useUrlFilters';
import useSearchParams from '@elementary/common-ui/hooks/useSearchParams';
import {
  fontSize,
  fontWeight,
  space,
  lineHeight,
} from '@elementary/common-ui/style/utils';
import { getTestResultsLink } from '../../utils';
import ContentWithLabel from '../shared/ContentWithLabel';

const ValueWrapper = styled(Flex)`
  gap: ${space('sm')};
  align-items: flex-end;
  margin-bottom: ${space('xl')};
`;

const Value = styled(Typography)`
  font-size: ${fontSize('displayXl')};
  font-weight: ${fontWeight('medium')};
  line-height: ${lineHeight('display')};
  color: ${({ theme }) => theme.palette.content.secondary};
`;

type Props = {
  total: number;
  selectedFilters: UrlFilters | undefined;
};

const TotalTests = ({ total, selectedFilters }: Props) => {
  const [searchParams] = useSearchParams();

  return (
    <ContentWithLabel
      variant="big"
      title="Total Tests"
      link={getTestResultsLink(searchParams, selectedFilters)}
    >
      <ValueWrapper>
        <Value>{total}</Value>
      </ValueWrapper>
    </ContentWithLabel>
  );
};

export default TotalTests;
